/**
 * Theme Configuration
 * Default theme for the Audio DAW canvas UI
 */
export const DEFAULT_THEME = {
  // Background colors
  background: "gray",
  trackBackground: "#f1f1f1",
  trackBackgroundDragging: "rgba(33, 150, 243, 0.2)",
  rulerBackground: "#2c2c2c",
  minimapBackground: "#1a1a1a",
  minimapTrackBackground: "#404040",

  // Grid
  gridColor: "rgba(255, 255, 255, 0.1)",
  gridLineWidth: 1,

  // Waveform
  defaultWaveformColor: "#2196F3",
  waveformLineWidth: 1,
  waveformGainScaling: true, // Enable visual scaling of waveform based on gain

  // Track border (when dragging)
  trackBorderColor: "#2196F3",
  trackBorderWidth: 2,

  // Track labels
  trackLabelColor: "#333",
  trackLabelFont: "12px sans-serif",
  trackLabelFontWeight: "normal",

  // Track offset display (when dragging)
  offsetDisplayBackground: "rgba(0, 0, 0, 0.7)",
  offsetDisplayColor: "#4CAF50",
  offsetDisplayFont: "12px monospace",
  offsetDisplayFontWeight: "normal",

  // Loading indicator
  loadingTextColor: "#333",
  loadingTextFont: "14px sans-serif",
  loadingTextFontWeight: "bold",

  // Timeline ruler
  rulerTickColor: "#666",
  rulerTextColor: "#ccc",
  rulerTextFont: "10px monospace",
  rulerTextFontWeight: "normal",
  rulerMajorTickHeight: 38,
  rulerMinorTickHeight: 30,
  rulerTickBottomMargin: 22, // Margin from bottom of canvas where ticks start

  // Playhead
  playheadColor: "#FF4081",
  playheadWidth: 2,

  // Minimap
  minimapWaveformOpacity: 0.6,
  minimapViewportFill: "rgba(255, 255, 255, 0.15)",
  minimapViewportStroke: "#4CAF50",
  minimapViewportStrokeWidth: 2,
  minimapPlayheadColor: "#FF4081",
  minimapPlayheadWidth: 1,

  // Scrollbar (legacy properties for backward compatibility)
  scrollbarTrackColor: "rgba(0, 0, 0, 0.15)",
  scrollbarThumbColor: "rgba(255, 255, 255, 0.4)",
  scrollbarThumbColorActive: "rgba(255, 255, 255, 0.7)",
  scrollbarThumbBorder: "rgba(0, 0, 0, 0.3)",
  scrollbarWidth: 16,

  // Scrollbar configuration object (recommended)
  scrollbar: {
    width: 16, // Thickness of scrollbars (vertical width, horizontal height)
    minThumbSize: 40, // Minimum thumb size in pixels
    trackColor: "rgba(0, 0, 0, 0.15)",
    thumbColor: "rgba(255, 255, 255, 0.4)",
    thumbColorActive: "rgba(255, 255, 255, 0.7)",
    thumbBorder: "rgba(0, 0, 0, 0.3)",
    showVertical: true,
    showHorizontal: true,
    customDrawFunction: null, // Optional: (ctx, geometry, isActive, theme, orientation) => void
  },

  // Selection
  selectionFill: "rgba(255, 193, 7, 0.2)",
  selectionBorder: "#FFC107",
  selectionBorderWidth: 2,
  selectionHandleColor: "#FFC107",
  selectionHandleWidth: 8,
};
